// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DWc7","clinicsSelect":"styles_clinicsSelect__31DB6"};